// 定义角色可访问的路由映射
export const roleRoutes = {
  '平台管理员': 'all', // 可访问所有路由
  '法人': {
    exclude: [
      '/AllCompany', // 企业管理
      '/ExamineCompany', // 公司证照审核
    ]
  }, 
  '企业管理员': {
    exclude: [
      // 不可访问的路由
      '/RescourceExamine', // 资源库审核
      '/ExamineCompany', // 公司证照审核
      '/ExamineProject', // 招投标审核
      '/ExamineTenderDetail', // 发布招标项目审核
      '/ExamineDecideTender', // 定/流标审核
      '/AllCompany', // 企业管理
      
    ]
  },
  '负责人': [
    '/login',     // 登录页
    '/LoginPage', // 登录页
    '/BeginUser', // 注册页
    '/RegisterPage', // 注册页
    '/RegisterResult', // 注册成功页
    '/HomeIndex', // 首页
    '/DefaultContent',  // 首页
    '/FirstPage', // 首页
    '/PersonalCenter', // 个人中心
    '/PersonalSettings', // 个人设置
    '/InnerNews', // 站内信
    '/LogManagement', // 日志管理
    '/EvaluationTasks', // 评估任务
    '/EvaluationRecords', // 评估记录
    '/EvaluationTasksDetail', // 评估任务详情
    '/EvaluationRecordsDetail', // 评估记录详情
    '/BidAnnouncement', // 招标公告
    '/ClarifyAnnouncement', // 发布澄清公告
    '/CompanyLicense', // 公司证照
    '/EditCompanyInfo', // 修改公司信息
    '/UserManagement', // 用户管理
    '/BidTasks', // 招标任务
    '/BidPush', // 招标发布
    '/BidPush2', // 招标发布2
    '/BidRecords', // 招标记录
    '/RecordsDetail', // 招标记录详情
    '/CompetBid', // 截标
    '/OpenBid', // 开标
    '/OverBid', // 流标审核
    '/DecideBid', // 定标
    '/DecideBidAnnouncement', // 定标公告发布
    '/AcceptanceArchive', // 项目归档与审核
    '/TenderClientList', // 客户名录
    '/UnInvite', // 填写需求
    '/PushInviteList', // 发起邀请
    '/DownClient', // 下游客户一览
    '/MyApplication', // 我收到的邀请
    '/UnInviteDetail', // 待入库申请详情
    '/TenderPublic', // 公开投标
    '/TenderTasks', // 投标任务
    '/TenderJoin', // 供应商报名
    '/DecideMoney', // 项目报价
    '/InviteTender', // 所受邀请
    '/TopClient', // 上游客户一览
    '/UnAgree', // 提交材料
    '/ApplicationList', // 发起申请
    '/RescourceExamine', // 资源库审核
    '/ExamineDetail', // 资源库审核详情
    '/ExamineCompanyDetail', // 公司证照详情
    '/ExamineProject', // 招投标项目审核
    '/ExamineProjectDetail', // 项目审批详情
    '/ExamineJoin', // 招投标项目审核供应商报名审核
    '/ExamineTenderDetail', // 招投标项目审核发布招标项目审核
    '/ExamineDecideTender', // 招投标项目审核定标审核
    '/TenderOver', // 投标记录详情页
    '/CompanyDetail', // 公司详情
    '/UnAgreeDetail', // 待审核邀请详情
    '/MyInvite', // 我收到的申请
    '/InnerNews', // 站内信
  ],
  '评委': [
    '/login',     // 登录页
    '/LoginPage', // 登录页
    '/BeginUser', // 注册页
    '/RegisterPage', // 注册页
    '/RegisterResult', // 注册成功页
    '/DefaultContent',  // 首页
    '/FirstPage',  // 首页
    '/PersonalCenter',  // 个人中心
    '/PersonalSettings',  // 个人设置
    '/InnerNews',  // 站内信
    '/LogManagement',  // 日志管理
    '/EvaluationTasks',  // 评估任务
    '/EvaluationRecords',  // 评估记录
    '/EvaluationTasksDetail',  // 评估任务详情
    '/EvaluationRecordsDetail',  // 评估记录详情
    '/BidAnnouncement',  // 招标公告
    '/ClarifyAnnouncement',  // 发布澄清公告
  ],
  '招标人': [
    '/login',     // 登录页
    '/LoginPage', // 登录页
    '/BeginUser', // 注册页
    '/RegisterPage', // 注册页
    '/RegisterResult', // 注册成功页
    '/BidPush2', // 招标发布2
    '/DefaultContent',  // 首页
    '/FirstPage',  // 首页
    '/PersonalCenter',  // 个人中心
    '/PersonalSettings',  // 个人设置
    '/InnerNews',  // 站内信
    '/LogManagement',  // 日志管理

    '/BidTasks',  // 招标任务
    '/BidPush',  // 招标发布
    '/BidRecords',  // 招标记录
    '/BidAnnouncement',  // 招标公告
    '/RecordsDetail', // 招标记录详情
    '/CompetBid',  // 截标
    '/OpenBid',  // 开标
    '/OverBid',  // 流标审核
    '/DecideBid',  // 定标
    '/ClarifyAnnouncement',  // 发布澄清公告
    '/DecideBidAnnouncement',  // 定标公告发布
    '/AcceptanceArchive',  // 项目归档与审核
    '/EvaluationTasksDetail',  // 评估任务详情
    '/DownClient',  // 下游客户一览
    '/UnInviteDetail', // 待入库申请详情
    '/MyApplication', // 我收到的邀请
    '/TenderClientList', // 客户名录
    '/UnInvite',     // 填写需求
    '/PushInviteList', // 发起邀请
  ],
  '投标人': [
    '/login',     // 登录页
    '/LoginPage', // 登录页
    '/BeginUser', // 注册页
    '/RegisterPage', // 注册页
    '/RegisterResult', // 注册成功页
    '/DefaultContent',  // 首页
    '/FirstPage',  // 首页
    '/PersonalCenter',  // 个人中心
    '/PersonalSettings',  // 个人设置
    '/InnerNews',  // 站内信
    '/LogManagement',  // 日志管理
    '/BidClientList', // 客户名录
    '/TenderPublic', // 公开投标
    '/TenderTasks', // 投标任务
    '/TenderJoin', // 供应商报名
    '/DecideMoney', // 项目报价
    '/InviteTender', // 所受邀请
    '/TenderOver', // 投标记录详情页
    '/TopClient', // 上游客户一览
    '/UnAgree',   // 提交材料
    '/ApplicationList', // 发起申请
  ],
}

// 过滤路由配置
export function filterRoutes(routes, role) {
  if (role === '平台管理员' || roleRoutes[role] === 'all') {
    return routes
  }

  const stack = [...routes]
  const result = []
  
  while (stack.length) {
    const current = stack.pop()
    
    if (current.children?.length) {
      const filteredChildren = current.children.filter(child => 
        roleRoutes[role]?.includes(child.path) &&
        !(roleRoutes[role]?.exclude?.includes(child.path))
      )
      
      if (filteredChildren.length) {
        current.children = filteredChildren
        result.push(current)
      }
    } else if (roleRoutes[role]?.includes(current.path) &&
               !(roleRoutes[role]?.exclude?.includes(current.path))) {
      result.push(current)
    }
  }
  
  return result
} 